import { EventEmitter, Injectable, Output } from "@angular/core";
import { MatDialog } from "@angular/material";
import { Observable } from "rxjs";
import { ConfirmationComponent } from "./confirmation/confirmation.component";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  @Output() confirmationAfterClosed = new EventEmitter<any>();
  @Output() confirmationConfirm = new EventEmitter<any>();
  @Output() confirmationCancel = new EventEmitter<any>();

  constructor(public dialog: MatDialog) {}

  confirmation(
    title: string,
    message: string,
    cancelText: string,
    confirmationText: string = "",
    size: string = "50%"
  ): Observable<any> {
    const dialog = this.dialog.open(ConfirmationComponent, {
      width: size,
      data: {
        title: title,
        message: message,
        cancelText: cancelText,
        confirmText: confirmationText,
      },
    });

    const obs = new Observable<any>((observer) => {
      this.confirmationConfirm.subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        }
      );

      this.confirmationCancel.subscribe(
        () => {
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        }
      );
    });

    dialog.afterClosed().subscribe((result) => {
      this.confirmationAfterClosed.emit(result);
    });

    return obs;
  }

  alert(
    title: string,
    message: string,
    cancelText: string,
    size: string = "50%"
  ): Observable<any> {
    const dialog = this.dialog.open(ConfirmationComponent, {
      width: size,
      data: {
        title: title,
        message: message,
        cancelText: cancelText,
        confirmText: "",
      },
    });

    const obs = new Observable<any>((observer) => {
      this.confirmationCancel.subscribe(
        () => {
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        }
      );
    });

    dialog.afterClosed().subscribe((result) => {
      this.confirmationAfterClosed.emit(result);
    });

    return obs;
  }
}
